<div
  class="admin-shell lg:h-screen lg:grid lg:grid-cols-6"
  [class.admin-shell--menu-open]="menuIsOpen"
>
  <button
    *ngIf="menuIsOpen"
    type="button"
    class="menu-backdrop"
    aria-label="Fermer le menu"
    (click)="closeMenu()"
  ></button>

  <section
    id="menu"
    class="admin-menu lg:col-span-1"
    [class.admin-menu--open]="menuIsOpen"
  >
    <app-menu
      (Clicked)="selectCurrentRoute($event)"
      (IsClicked)="closeMenu()"
      [activeRoute]="activeRoute"
    ></app-menu>
  </section>
  <main class="admin-main col-span-6 lg:col-span-5">
    <div class="admin-topbar w-full">
      <app-header></app-header>
    </div>
    <div class="admin-route-content">
      <router-outlet (activate)="changeOfRoutes()"></router-outlet>
    </div>
  </main>
</div>

<button
  *ngIf="!menuIsOpen"
  type="button"
  class="mobile-menu-button"
  aria-label="Ouvrir le menu"
  aria-controls="menu"
  (click)="openMenu()"
>
  <img
    draggable="false"
    src="assets/svg/burger-menu.svg"
    alt=""
  />
</button>
